const fetchOpeningTimes = async ( instance, containers ) => {
  try {
    const baseUrl = window.openingtimes_rest_url || ajaxurl;
    const isAjax = baseUrl === ajaxurl;
    const method = isAjax ? 'POST' : 'GET';
    const url = isAjax
      ? baseUrl
      : baseUrl + ( baseUrl.includes( '?' ) ? '&' : '?' ) + 'instance=' + encodeURIComponent( instance );

    const response = await fetch( url, {
      method: method,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: isAjax ? new URLSearchParams( {
        action: 'get_current_opening_time',
        instance,
        timestamp: +new Date(),
      } ) : null,
      credentials: 'same-origin',
    } );

    if (!response.ok) {
      throw new Error( 'Network response was not ok' );
    }

    const data = await response.json();

    if (!data.success) {
      console.error( 'Error fetching opening times' );
      console.log( data );
      return;
    }

    containers.forEach( container => {
      container.innerHTML = data.data.text;
      if ( data.data.next ) {
        container.innerHTML += ' ' + data.data.next_fmt;
      }
      if ( data.data.current_time ) {
        container.innerHTML += '<div class="current-time" aria-hidden="true">' + data.data.current_time_fmt + '</div>';
      }
      if ( !container.classList.contains( 'bound' ) ) {
        container.addEventListener( 'click', ( e ) => {
          if ( e.shiftKey ) {
            fetchOpeningTimes( instance, containers );
          }
        } );
        // add mouseover with shift to toggle a konami class
        container.addEventListener( 'mouseover', ( e ) => {
          if ( e.shiftKey ) {
            container.classList.toggle( 'konami' );
          }
        } );
      }
      container.classList.add( 'bound' );
    } );
  } catch (error) {
    console.error( 'Fetch error:', error );
  }
};

const fetchAll = ( groups ) => {
  groups.forEach( ( { instance, containers } ) => fetchOpeningTimes( instance, containers ) );
};

const init = () => {
  const containers = [...document.querySelectorAll( '.opening-times-container' )];

  if (containers.length === 0) {
    return;
  }

  // Group containers by their data-instance (defaulting when absent).
  const byInstance = containers.reduce( ( map, container ) => {
    const instance = container.dataset.instance || 'default';
    ( map[instance] = map[instance] || [] ).push( container );
    return map;
  }, {} );

  const groups = Object.keys( byInstance ).map( instance => ( {
    instance,
    containers: byInstance[instance],
  } ) );

  fetchAll( groups );
  setInterval( () => fetchAll( groups ), 60 * 1000 );
}

export default init;
